import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-time-table",
  templateUrl: "./time-table.component.html",
})
export class TimeTableComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
